import {mergeConfig} from '../../configStore'
import {field} from '../field'
import {CategoriesField, FieldReturn} from '../../types'

export const categories = (
  _types: string | string[],
  props?: CategoriesField,
  mergeProps?: Partial<CategoriesField>,
): FieldReturn => {
  const types = Array.isArray(_types) ? _types : [_types]

  const defaultProps: Partial<CategoriesField> = {
    name: 'categories',
    options: {
      types,
    },
  }

  return field('multiReference', mergeConfig('categories', props, mergeProps, defaultProps))
}
